import React from 'react'

import { Page } from 'app/templates'

import { styled, theme } from 'ui/styles'
import { Text } from 'ui/components'
import { breakpoints } from 'shared/dimensions'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: auto;
  padding: 0 64px 56px;
  z-index: 100;
  backdrop-filter: blur(12px);
  background: rgba(42, 61, 87, 0.95);

  @media (max-width: ${breakpoints.tablet}px) {
    padding: 0 32px 56px;
  }
`

const Content = styled.div`
  max-width: 850px;
`

const HeaderWrapper = styled.div`
  padding-top: 56px;

  display: flex;
  flex-direction: column;
  gap: 12px;

  :not(:first-of-type) {
    padding-top: 64px;
  }
`

export const Price: React.FC = () => {  
  return (
    <Page>
      <Wrapper>
        <Content>
          <HeaderWrapper>
            <Text variant="h3" color={theme.palette.white}>
              Стоимость услуг
            </Text>
            <Text bold variant="t3" color={theme.palette.white}>
              Минимальная стоимость проекта - 100 000 рублей.
            </Text>
            <Text variant="t3" color={theme.palette.white}>
              Окончательная цена определяется на основании коммерческого предложения
              (сметы), которое подготавливается после получения детализированной заявки
              от Заказчика и проведения всех необходимых расчетов.
            </Text>
          </HeaderWrapper>
        </Content>
      </Wrapper>
    </Page>
  )
}
